import { create } from 'zustand'
import { Organization } from '@/types'
import * as api from '@/services/api'

interface OrganizationState {
  organizations: Organization[]
  currentOrganization: Organization | null
  isLoading: boolean
  error: string | null
  fetchOrganizations: () => Promise<void>
  fetchOrganizationById: (id: string) => Promise<void>
}

const useOrganizationStore = create<OrganizationState>((set) => ({
  organizations: [],
  currentOrganization: null,
  isLoading: false,
  error: null,

  fetchOrganizations: async () => {
    set({ isLoading: true, error: null })
    try {
      const organizations = await api.getOrganizations()
      set({ organizations, isLoading: false })
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to fetch organizations.'
      set({ error: errorMessage, isLoading: false, organizations: [] })
    }
  },

  fetchOrganizationById: async (id: string) => {
    set({ isLoading: true, error: null, currentOrganization: null })
    try {
      const organization = await api.getOrganizationById(id)
      set({ currentOrganization: organization, isLoading: false })
    } catch (error) {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'Failed to fetch organization details.'
      set({ error: errorMessage, isLoading: false })
    }
  },
}))

export default useOrganizationStore
